export default __webpack_public_path__ + "static/media/skeleton_seated.5e09f19c.svg";